import { Injectable } from '@angular/core';

import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { from, Observable } from 'rxjs';
import { AuthLibService } from '@landg_eap/auth-lib';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { SERVICE_END_POINT } from '../services/api-constants/service-endpoints.constants';
import { ConfigLoaderService } from '../services/api-services/configLoader.service';

@Injectable({
  providedIn: 'root'
})

export class CredentialsInterceptor implements HttpInterceptor {

  url: any;
  authCheck: any;
  endpoints = SERVICE_END_POINT.higherEnvironment
  constructor(private auth: AuthLibService, private route: Router, private injector: Injector, private configLoaderService: ConfigLoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req && req.url ? req.url : '';
    const skipUrlFlag = url && this.skipUrl(url) ? true : false;
    if (skipUrlFlag || sessionStorage.getItem('logInClicked') === 'N') {
      return this.handleInvalidSession(req, next, false);
    } else {
      return from(this.auth.checkSessionAndToken(this.configLoaderService.configuration.am_url, this.configLoaderService.configuration.realm_path, this.configLoaderService.configuration.web_oauth_client)).pipe(
        mergeMap((isValidSession: boolean) => (isValidSession && url && url.includes('/eap/') && !skipUrlFlag) ?
          this.handleValidSession(req, next) :
          ((isValidSession && url && !url.includes('/eap/') && !skipUrlFlag) ? this.handleInvalidSession(req, next, false) : this.handleInvalidSession(req, next, true))
        )
      );
    }
  }

  skipUrl(url: string): boolean {
    if (url && (url.includes('envconfigdcj') || url.includes('cms') || url.includes('CMS_Data') || url.includes('brms')
      || url.includes('assets/json') || url.includes('/address/'))) {
      return true;
    }
    return false;
  }
  private handleValidSession(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.auth.getToken()).pipe(
      mergeMap((token: any) => {
        const accessToken = token.accessToken;
        let clonedRequest = req;
        if (sessionStorage.getItem('logInClicked') === 'Y') {          
          clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${accessToken}`
            }
          });
          if (clonedRequest && clonedRequest.url && this.configLoaderService.configuration.triggeredBy === 'HOUser') {
            if ((clonedRequest.url).includes('dcj/apply/')) {
              clonedRequest = clonedRequest.clone({ url: clonedRequest.url.replace('dcj/', 'hoapply/') });
            } else if ((clonedRequest.url).includes('dcj/quote/')) {
              clonedRequest = clonedRequest.clone({ url: clonedRequest.url.replace('dcj/', 'ho/') });
            }
          }
        } else {
          clonedRequest = this.checkAndUpdateEndPoint(req);
        }
        return next.handle(clonedRequest);
      })
    );
  }

  private handleInvalidSession(req: HttpRequest<any>, next: HttpHandler, redirectFlag: boolean): Observable<HttpEvent<any>> {
    if (redirectFlag) {
      this.route.navigate(['/']);
    }
    return next.handle(this.checkAndUpdateEndPoint(req));
  }
  checkAndUpdateEndPoint(req: HttpRequest<any>): HttpRequest<any> {
    let clonedReq;
    if (req && req.url) {
      clonedReq = req.clone({ url: req.url.replace('dcj/', 'anonymous/') });
    }
    return clonedReq;
  }
}


